import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupChannelsLayout } from "@/features/study-group-channels/components/StudyGroupChannelsLayout";

const ProtoForAdminRoute = () => <StudyGroupChannelsLayout studyGroupId={1} />;

export const Route = createFileRoute("/proto-for-admin")({
  component: ProtoForAdminRoute,
});
